import { getIntlNumberSeparators } from './get-intl-number-separators';

export function getNumberFromIntlString(value: string, language?: string) {
  const { thousandSeparator, decimalSeparator } =
    getIntlNumberSeparators(language);

  return parseFloat(
    value.replace(thousandSeparator, '').replace(decimalSeparator, '')
  );
}
